import {
  TextInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  ReferenceArrayInput,
  AutocompleteInput,
  AutocompleteArrayInput,
  required,
  maxLength,
  minLength,
} from "react-admin";
import { Grid } from "@mui/material";
import { StudyDurationUnitChoices } from "utils/choices";
import { administrationRequests } from "api/administrationApi";
import { specialistRequests } from "api/specialistApi";

const NAMES_MAX_LENGTH = 200;

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameBg"
          label="Наименование (БГ)"
          validate={[required(), maxLength(NAMES_MAX_LENGTH), minLength(1)]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameEn"
          label="Наименование (EN)"
          validate={[required(), maxLength(NAMES_MAX_LENGTH), minLength(1)]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="specializationId"
          reference={specialistRequests.getSpecializationsSelect()}
        >
          <AutocompleteInput
            optionText="nameBg"
            label="Специалност"
            fullWidth
            validate={[required()]}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <SelectInput
          source="studyDurationUnit"
          label="Единица за продължителност"
          choices={StudyDurationUnitChoices}
          validate={[required()]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <NumberInput
          source="studyDuration"
          label="Продължителност"
          fullWidth
          onWheel={e => e.target.blur()}
          validate={[required()]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="certValidityYears"
          label="Валидност на сертификат (год.)"
          fullWidth
          validate={[required()]}
          onWheel={e => e.target.blur()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceArrayInput
          source="buildingIds"
          reference={administrationRequests.getBuildingsSelect()}
        >
          <AutocompleteArrayInput
            optionText="name"
            label="Сгради"
            validate={[required()]}
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>
    </Grid>
  );
};

export default SaveForm;
